import { useContext } from 'react'

import { ParametersBudgetContext } from '@provider/Budget/ParametersProvider'

import type { IBudgetParametersContext } from '@base/@types/providers/Budget/parameters'

export default function useConciliationStoreBudget(): IBudgetParametersContext {
  const context = useContext(ParametersBudgetContext)

  return context
}
